/* Lightweight init for DocMind AI page (Template-DocMindAi.js) */
(function() {
  'use strict';

  /* Layer accordion (used in Capability section) */
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-layer-trigger]');
    if (!trigger) return;
    const item = trigger.closest('[data-layer-item]');
    if (!item) return;
    const isOpen = item.classList.contains('is-open');
    // Close siblings within same accordion
    const accordion = item.closest('[data-layer-accordion]');
    if (accordion) {
      accordion.querySelectorAll('[data-layer-item]').forEach(function(s) { s.classList.remove('is-open'); });
    }
    if (!isOpen) item.classList.add('is-open');
  });

  /* FAQ accordion (clean toggle, multi-open allowed) */
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-faq-trigger]');
    if (!trigger) return;
    const item = trigger.closest('[data-faq-item]');
    if (!item) return;
    item.classList.toggle('is-open');
  });

  /* Smooth-scroll for anchor links inside page */
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      const id = this.getAttribute('href');
      if (id.length <= 1) return;
      const target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* Hero viz - trigger entry animation sequence on load */
  const heroViz = document.querySelector('[data-hero-viz]');
  if (heroViz) {
    /* Small delay so first paint is clean before animation starts */
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        heroViz.classList.add('is-active');
      });
    });
  }

  ComponentManager.init(document.body);
})();
